import React, { useEffect, useState } from "react";
import { Card, Button, Spin } from "antd";
import axios from "axios";
import {
  PlayCircleOutlined,
  VideoCameraOutlined,
  ProfileOutlined,
  ReadOutlined,
  SolutionOutlined,
  CalendarOutlined
} from "@ant-design/icons";
import { ToastContainer } from "react-toastify";
import VideoPlayer from "../VideoPlayer";
import dayjs from "dayjs";

function InstructorHomePage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [classData, setClassData] = useState(null);

  const [jobs, setJobs] = useState([]);

  const [interviews, setInterviews] = useState([]);

  useEffect(() => {
    fetchResumeData();
  }, []);

  const fetchResumeData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/course/resume-course/data`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        setData(res.data.data || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const completed = data.find((d) => d.type === "COMPLETED");
  const next = data.find((d) => d.type === "NEXT");

  const fetchJobs = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/jobs/all`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data.success) {
      setJobs(res.data.data || []);
    }
  } catch (err) {
    console.error("❌ Fetch Jobs Error:", err);
  }
};



useEffect(() => {
  fetchJobs();
}, []);

const recentJobs = jobs.slice(0, 2);

const fetchInterviews = async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/mock-interview/get-instructor-interviews`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      setInterviews(res.data.data || []);
    }

    setLoading(false);
  } catch (err) {
    setLoading(false);
   
  }
};

useEffect(() => {
  fetchInterviews();
}, []);

const activeInterviews = interviews
  .filter(
    (i) =>
      i.InterviewStatus === "SCHEDULED" ||
      i.InterviewStatus === "RESCHEDULED"
  )
  .slice(0, 2);

  /* ================= LOADING ================= */
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6 bg-gray-50">
      <ToastContainer />
<h1 className="flex items-center gap-3 font-sans text-2xl font-bold text-slate-900">
  Instructor Dashboard
  
</h1>
      {/* ================= NO COURSE BANNER ================= */}
      {!completed && !next && (
        <div className="flex items-center gap-4 p-5 mb-6 border border-yellow-200 rounded-2xl bg-yellow-50">

          <div className="flex items-center justify-center w-12 h-12 bg-yellow-100 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-yellow-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4m0 4h.01M4.93 19h14.14c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.2 16c-.77 1.33.19 3 1.73 3z"
              />
            </svg>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-yellow-800">
              Courses Not Assigned Yet
            </h3>
            <p className="mt-1 text-xs text-yellow-700">
              You currently do not have access to any active courses.
              Please contact the Operations Team to get enrolled.
            </p>
          </div>

        </div>
      )}

      {/* ================= GRID ================= */}
      <div className="grid grid-cols-1 gap-3 p-4 rounded-xl md:grid-cols-2 bg-slate-200">

        {/* ================= JOIN LIVE ================= */}
        <Card className="border border-gray-200 shadow-sm rounded-2xl">

          <div className="p-2">

            {/* HEADER */}
            <div className="flex items-center gap-4 mb-6">

              <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-green-50">
                <VideoCameraOutlined className="text-xl text-green-500" />
              </div>

              <div>
                <h2 className="text-lg font-semibold text-slate-900">
                  Join Live Session
                </h2>
                <p className="text-xs text-gray-500">
                  Attend your upcoming session
                </p>
              </div>

            </div>

            {next ? (
              <>
                {/* COURSE NAME */}
                <p className="mb-3 text-base font-bold tracking-wide text-green-600 uppercase">
                  {next.CourseName}
                </p>

                {/* CONTENT */}
                <div className="p-4 mb-6 border border-gray-100 rounded-xl bg-green-50">

                  <p className="text-sm font-semibold text-slate-800">
                    <span className="p-1 text-xs text-white bg-green-600 border-2 border-green-500 rounded-md">Upcoming Session :</span> {next.ClassName}
                  </p>

                  <div className="flex items-center gap-2 mt-2 text-xs font-semibold text-gray-700">
                    <span className="px-2 py-0.5 bg-orange-300 border rounded-md">
                      Module {next.ModuleNumber}
                    </span>
                    <span>•</span>
                    <span>{next.ModuleName}</span>
                  </div>

                </div>

                <Button
                  
                  icon={<VideoCameraOutlined />}
                  size="large"
                  className="w-full font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 h-11"
                  onClick={() => window.open(next.LiveUrl, "_blank")}
                >
                  Join Live Class
                </Button>
              </>
            ) : (
              <div className="py-10 text-center">
                <p className="text-sm text-gray-400">
                  No upcoming sessions scheduled
                </p>
              </div>
            )}

          </div>
        </Card>

        {/* ================= WATCH RECORDING ================= */}
        <Card className="border border-gray-200 shadow-sm rounded-2xl">

          <div className="p-2">

            {/* HEADER */}
            <div className="flex items-center gap-4 mb-6">

              <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-blue-50">
                <PlayCircleOutlined className="text-xl text-blue-600" />
              </div>

              <div>
                <h2 className="text-lg font-semibold text-slate-900">
                  Watch Recording
                </h2>
                <p className="text-xs text-gray-500">
                  Resume your last completed session
                </p>
              </div>

            </div>

            {completed ? (
              <>
                {/* COURSE NAME */}
                <p className="mb-3 text-base font-bold tracking-wide text-blue-600 uppercase">
                  {completed.CourseName}
                </p>

                {/* CONTENT */}
                <div className="p-4 mb-6 border border-gray-100 rounded-xl bg-blue-50">

                  <p className="text-sm font-semibold text-slate-800">
                   <span className="p-1 text-xs text-white bg-blue-600 border-2 border-blue-700 rounded-md">Previuos Session :</span> {completed.ClassName}
                  </p>

                  <div className="flex items-center gap-2 mt-2 text-xs font-semibold text-gray-700">
                    <span className="px-2 py-0.5 bg-orange-300 border rounded-md">
                      Module {completed.ModuleNumber}
                    </span>
                    <span>•</span>
                    <span>{completed.ModuleName}</span>
                  </div>

                </div>

                <Button
                  type="primary"
                  icon={<PlayCircleOutlined />}
                  size="large"
                  className="w-full font-medium rounded-lg h-11"
                  onClick={() => {
                    setVideoUrl(completed.RecordingUrl);
                    setClassData(completed);
                    setIsPlayerOpen(true);
                  }}
                >
                  Watch Recording
                </Button>
              </>
            ) : (
              <div className="py-10 text-center">
                <p className="text-sm text-gray-400">
                  No completed sessions available
                </p>
              </div>
            )}

          </div>
        </Card>

        <Card
  onClick={() => window.location.href = "/academy/mentor-dashboard/jobs"}
  className="mt-0 transition border border-gray-200 shadow-sm cursor-pointer rounded-2xl hover:shadow-md"
>
  <div className="p-2">

    {/* HEADER */}
    <div className="flex items-center justify-between mb-6">

      <div className="flex items-center gap-4">
        <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-indigo-50">
          <SolutionOutlined className="text-xl text-indigo-600" />
        </div>
 
        <div>
          <h2 className="text-lg font-semibold text-slate-900">
            Recent Job Openings
          </h2>
          <p className="text-xs text-gray-500">
            Latest openings for you
          </p>
        </div>
      </div>

      <span className="text-xs font-medium text-indigo-600">
        View All →
      </span>

    </div>

    {/* CONTENT */}
    {recentJobs.length > 0 ? (
      <div className="space-y-4">

        {recentJobs.map((job) => (
          <div
            key={job.id}
            className="flex items-center gap-4 p-3 transition bg-gray-200 border border-gray-200 rounded-xl hover:bg-gray-100"
          >

            {/* LOGO */}
            <div className="flex items-center justify-center w-12 h-12 bg-white border rounded-lg">
              {job.CompanyLogo ? (
                <img
                  src={job.CompanyLogo}
                  alt="logo"
                  className="object-contain w-8 h-8"
                />
              ) : (
                <span className="text-xs font-bold text-gray-400">
                  {job.CompanyName?.[0]}
                </span>
              )}
            </div>

            {/* DETAILS */}
            <div className="flex-1">

              <p className="text-sm font-semibold text-slate-800">
                {job.JobTitle}
              </p>

              <div className="flex items-center gap-2 mt-1 text-xs text-gray-700">
                <span className="px-2 py-0.5 font-semibold bg-cyan-700  text-white border rounded-md">
                  {job.PositionType}
                </span>

                <span>•</span>

                <span className="font-semibold">{job.Location}</span>
              </div>

            </div>

          </div>
        ))}

      </div>
    ) : (
      <div className="py-10 text-center">
        <p className="text-sm text-gray-400">
          No job openings available
        </p>
      </div>
    )}

  </div>
</Card>



<Card
  onClick={() =>
    (window.location.href =
      "/academy/mentor-dashboard/mock-interviews")
  }
  className="mt-0 transition border border-gray-200 shadow-sm cursor-pointer rounded-2xl hover:shadow-md"
>
  <div className="p-2">

    {/* HEADER */}
    <div className="flex items-center justify-between mb-6">

      <div className="flex items-center gap-4">
        <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-purple-50">
          <CalendarOutlined className="text-xl text-purple-600" />
        </div>

        <div>
          <h2 className="text-lg font-semibold text-slate-900">
            Upcoming Mock Interviews
          </h2>
          <p className="text-xs text-gray-500">
            Your upcoming interview sessions
          </p>
        </div>
      </div>

      <span className="text-xs font-medium text-purple-600">
        View All →
      </span>

    </div>

    {/* TABLE HEADER */}
    {activeInterviews.length > 0 && (
      <div className="grid grid-cols-4 px-3 mb-2 text-xs font-semibold text-gray-400 uppercase">
        <span>Course</span>
        <span>Status</span>
        <span>Date</span>
        <span>Time</span>
      </div>
    )}

    {/* CONTENT */}
    {activeInterviews.length > 0 ? (
      <div className="space-y-3">

        {activeInterviews.map((item) => (
          <div
            key={item.id}
            className="grid items-center grid-cols-4 gap-2 p-3 text-sm transition border border-gray-100 rounded-xl bg-gray-50 hover:bg-gray-100"
          >

            {/* COURSE */}
            <span className="font-medium text-slate-800">
              {item.CourseName}
            </span>

            {/* STATUS */}
            <span
              className={`text-xs font-semibold px-2 py-0.5 rounded-md w-fit
                ${
                  item.InterviewStatus === "SCHEDULED"
                    ? "bg-blue-100 text-blue-700"
                    : "bg-yellow-100 text-yellow-700"
                }
              `}
            >
              {item.InterviewStatus}
            </span>

            {/* DATE */}
            <span className="text-gray-600">
              {dayjs(item.ScheduledDate).format("DD MMM")}
            </span>

            {/* TIME */}
            <span className="text-gray-600">
              {item.ScheduledTime}
            </span>

          </div>
        ))}

      </div>
    ) : (
      <div className="py-10 text-center">
        <p className="text-sm text-gray-400">
          No scheduled interviews available
        </p>
      </div>
    )}

  </div>
</Card>

      </div>

      {/* ================= VIDEO PLAYER ================= */}
      {isPlayerOpen && videoUrl && (
        <div className="fixed inset-0 z-[9999] flex flex-col bg-black">

          <div className="flex items-center justify-between px-6 py-4 bg-black/80 backdrop-blur-md">

            <button
              onClick={() => {
                setIsPlayerOpen(false);
                setVideoUrl(null);
                setClassData(null);
              }}
              className="flex items-center gap-2 text-lg font-semibold text-white transition hover:text-red-400"
            >
              ← Back
            </button>

            <h2 className="text-lg font-medium text-center text-white">
              {classData?.ClassName} Session Recording
            </h2>

            <div className="w-[80px]" />
          </div>

          <div className="flex items-center justify-center flex-1 bg-black">
            <div className="w-full h-full mx-auto max-w-7xl">
              <VideoPlayer key={videoUrl} url={videoUrl} />
            </div>
          </div>

        </div>
      )}
    </div>
  );
}

export default InstructorHomePage;